<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="login_titleBox">
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title">
            <img src="../../assets/images/login_logo.png" />
            《{{ $store.state.Name }}》{{ titlea }} —
            <span class="highorange">{{ title }}</span>
          </div>
        </div>
        <div class="login_maxBox">
          <div class="container login_box" v-if="status == 1 && isLoginCode">
            <el-tabs
              v-model="activeNames"
              @tab-click="handleClicks"
              class="loginList"
            >
              <el-tab-pane label="二次验证" name="firsts" class="ten">
                <el-form>
                  <div class="twenfive" style="margin-top: 0px">
                    <div class="highgreen">
                      系统已经发送验证码到{{
                        mobelEm
                      }}，若未收到验证码，请到邮件垃圾箱中查找一下。
                    </div>
                  </div>
                  <el-form-item
                    label="邮箱验证码:"
                    :rules="[{ required: true }]"
                    style="margin-top: 15px"
                  >
                    <el-col :md="14" :lg="14" :xl="14">
                      <el-input
                        v-model="form.yzcodes"
                        placeholder="请输入邮箱验证码"
                      ></el-input>
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error" v-html="yzcodesTiShi"></div>
                  </el-form-item>
                  <el-form-item label="">
                    <el-button
                      style="width: 48%"
                      type="primary"
                      @click="Login(tab, 2)"
                      >确认</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >取消</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?
                <a href="javascript:void(0)" @click="$router.push('/regist')"
                  >立即注册</a
                >
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;
                <a href="javascript:void(0)" @click="$router.push('/')"
                  >返回首页</a
                >
              </p>
              <p class="text-center" v-if="isweixin || IsQQLogin">
                已经有<span v-if="IsQQLogin">QQ，</span>
                <span v-if="isweixin">微信</span
                >账号，可直接登录，不用重复注册。
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <el-button
                  v-if="isweixin"
                  type="text"
                  @click="wxshow()"
                  class="weixin"
                >
                  <img src="../../assets/images/add_wx1.png" />
                </el-button>
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>
                    <div>
                      <img :src="src" width="150" height="150" style />
                    </div>
                  </div>
                </el-dialog>
                <a
                  style="cursor: pointer"
                  @click="useqqlogin"
                  class="qq_login"
                  v-if="IsQQLogin"
                >
                  <img src="../../assets/images/add_qq1.png" />
                </a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="container login_box" v-else>
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              class="loginList"
            >
              <el-tab-pane label="用户名登录" name="first" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="70px"
                  class="twenfive"
                  @submit.native.prevent
                >
                  <div v-if="status != 1">
                    <el-form-item label="用户名:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="请输入用户名"
                          @input="oninput()"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          请输入用户名
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="密码:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>
                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。请<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >点击此处</router-link
                          >修改密码。</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="验证码:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="请输入验证码"
                          @keyup.enter.native="Login(1)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <img
                            @click="initVeri()"
                            width="100"
                            class="yamsss"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                        </span>
                      </el-col>
                      <div class="clearfix"></div>
                      <div
                        class="msg_error yzms"
                        style="width: 100%"
                        v-show="yzhid"
                      >
                        {{ yzhid }}
                      </div>
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(1)"
                        >登录</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(1, 1)"
                        >登录</el-button
                      >
                    </el-form-item>
                  </div>
                  <el-form-item label>
                    <div class="leftfloat login_pwd" style="margin-left: 3px">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >找回密码</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane label="邮箱登录" name="second" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  class="twenfive"
                  @submit.native.prevent
                >
                  <div v-if="status != 1">
                    <el-form-item label="邮箱:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="请输入邮箱"
                          @input="oninput"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          请输入邮箱
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="密码:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>

                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。请<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >点击此处</router-link
                          >修改密码。</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="验证码:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="请输入验证码"
                          @click.native="Login(2)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <img
                            @click="initVeri()"
                            width="100"
                            class="yamsss"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                        </span>
                      </el-col>
                      <div
                        class="msg_error yzms"
                        style="width: 100%"
                        v-show="yzhid"
                      >
                        {{ yzhid }}
                      </div>
                    </el-form-item>

                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(2)"
                        >登录</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(2, 1)"
                        >登录</el-button
                      >
                    </el-form-item>
                  </div>
                  <el-form-item label>
                    <div class="leftfloat" style="margin-left: 3px">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >找回密码</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane
                label="手机登录"
                name="third"
                class="ten"
                v-if="isphones"
              >
                <el-form
                  ref="form"
                  :model="form"
                  label-width="70px"
                  @submit.native.prevent
                  class="twenfive"
                >
                  <div v-if="status != 1">
                    <el-form-item label="手机:">
                      <el-col>
                        <el-input
                          v-model="form.user"
                          placeholder="请输入手机"
                          @input="oninput"
                        ></el-input>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          请输入手机
                        </div>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="密码:">
                      <el-col>
                        <el-input
                          v-model="form.pass"
                          placeholder="请输入密码"
                          show-password
                          @blur="DetectInput($event, 'pws')"
                        ></el-input>
                      </el-col>
                      <div class="msg_error" v-show="passhid">
                        {{ passhid }}
                      </div>
                      <div class="clearfix"></div>
                      <div
                        class="five five msg_error"
                        style="zoom: normal"
                        v-if="pwdErr"
                      >
                        <span
                          >根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。请<router-link
                            to="/ChangePassword"
                            style="color: #428bca"
                            >点击此处</router-link
                          >修改密码。</span
                        >
                      </div>
                    </el-form-item>
                    <el-form-item label="验证码:">
                      <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                        <el-input
                          v-model="form.yzcode"
                          placeholder="请输入验证码"
                          @click.native="Login(3)"
                        ></el-input>
                      </el-col>
                      <el-col
                        :xs="8"
                        :sm="8"
                        :md="8"
                        :lg="8"
                        :xl="8"
                        class="ml15"
                      >
                        <span style="cursor: pointer">
                          <img
                            @click="initVeri()"
                            width="100"
                            class="yamsss"
                            :src="'data:image/png;base64,' + Picturebase"
                            alt="无效"
                          />
                        </span>
                      </el-col>
                      <div
                        class="msg_error yzms"
                        style="width: 100%"
                        v-show="yzhid"
                      >
                        {{ yzhid }}
                      </div>
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-if="!isLoginCode">
                      <el-button type="primary" @click="Login(3)"
                        >登录</el-button
                      >
                    </el-form-item>
                    <el-form-item label class="loginbtn" v-else>
                      <el-button type="primary" @click="Login(3, 1)"
                        >登录</el-button
                      >
                    </el-form-item>
                  </div>
                  <el-form-item label>
                    <div class="leftfloat" style="margin-left: 3px">
                      <el-checkbox v-model="checked">记住密码</el-checkbox>
                    </div>
                    <div class="rightfloat">
                      <a
                        class="highblue"
                        @click="$router.push('/LookforPassword')"
                        style="cursor: pointer"
                        >找回密码</a
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>

              <el-tab-pane
                label="手机验证码登录"
                name="forth"
                class="ten"
                v-if="isMobile"
              >
                <el-form
                  ref="form"
                  :model="form"
                  label-width="90px"
                  @submit.native.prevent
                  class="twenfive"
                >
                  <div v-if="status != 1">
                    <el-form-item label="手机:">
                      <el-col :md="16" :lg="14" :xl="14" :sm="16">
                        <el-input
                          v-model="form.user"
                          placeholder="请输入手机"
                          @input="oninput"
                          @blur="DetectInput($event, 'phone')"
                        ></el-input>
                        <div class="msg_error" v-html="phoneTiShi"></div>
                        <div class="msg_error" v-show="userhid">
                          {{ userhid }}
                        </div>
                        <div style="display: none" class="msg_error">
                          请输入手机号
                        </div>
                      </el-col>
                      <el-col
                        :md="8"
                        :lg="8"
                        :xl="8"
                        :sm="8"
                        class="leftfloat ml1 myzm"
                        v-if="isshurus"
                      >
                        <el-button type="primary" plain @click="aaa()"
                          >验证手机号是否可用</el-button
                        >
                      </el-col>
                    </el-form-item>
                    <div v-if="isShows">
                      <el-form-item v-if="!isShow" label="验证码:">
                        <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
                          <el-input
                            v-model="form.yzcode"
                            placeholder="请输入验证码"
                            @click.native="Login(3)"
                          ></el-input>
                        </el-col>

                        <el-col
                          :xs="8"
                          :sm="8"
                          :md="8"
                          :lg="8"
                          :xl="8"
                          class="ml15"
                        >
                          <span style="cursor: pointer">
                            <img
                              @click="initVeri()"
                              width="100"
                              class="yamsss"
                              :src="'data:image/png;base64,' + Picturebase"
                              alt="无效"
                            />
                          </span>
                        </el-col>
                        <div
                          class="msg_error yzms"
                          style="width: 100%"
                          v-show="yzhid"
                        >
                          {{ yzhid }}
                        </div>
                        <div class="msg_error" v-html="codeTiShis"></div>
                      </el-form-item>
                      <el-form-item v-else label="短信验证码:">
                        <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                          <el-input
                            v-model="form.yzcodes"
                            placeholder="请输入短信验证码"
                          ></el-input>
                        </el-col>
                        <div class="msg_error" v-html="codeTiShis"></div>
                      </el-form-item>
                      <el-form-item label class="loginbtn" v-if="!isShow">
                        <el-button type="primary" @click="sendCodeBtn"
                          >发送验证码</el-button
                        >
                      </el-form-item>
                      <el-form-item label v-else class="loginbtn">
                        <el-button type="primary" @click="Login(4)"
                          >登录</el-button
                        >
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
                <div class="clearfix"></div>
              </el-tab-pane>
            </el-tabs>

            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?
                <a href="javascript:void(0)" @click="$router.push('/regist')"
                  >立即注册</a
                >
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;
                <a href="javascript:void(0)" @click="$router.push('/')"
                  >返回首页</a
                >
              </p>
              <p class="text-center" v-if="isweixin || IsQQLogin">
                已经有<span v-if="IsQQLogin">QQ，</span>
                <span v-if="isweixin">微信</span
                >账号，可直接登录，不用重复注册。
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <el-button
                  v-if="isweixin"
                  type="text"
                  @click="wxshow()"
                  class="weixin"
                >
                  <img src="../../assets/images/add_wx1.png" />
                </el-button>
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>
                    <div>
                      <img :src="src" width="150" height="150" style />
                    </div>
                  </div>
                </el-dialog>
                <a
                  style="cursor: pointer"
                  @click="useqqlogin"
                  class="qq_login"
                  v-if="IsQQLogin"
                >
                  <img src="../../assets/images/add_qq1.png" />
                </a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）。请<router-link
            to="/ChangePassword"
            style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title="验证码验证"
      :visible.sync="isShowss"
      custom-class="dialogwidth"
      :show-close="false"
    >
      <el-form @submit.native.prevent>
        <el-form-item>
          <el-col
            :xs="6"
            :sm="6"
            :md="6"
            :lg="6"
            :xl="6"
            style="text-align:right"
            >验证码:&nbsp;&nbsp;</el-col
          >
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <el-input v-model="yzcodesss" placeholder="请输入验证码"></el-input>
            <div class="msg_error" v-html="phoneTiShis"></div>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" class="ml15">
            <span style="cursor: pointer">
              <div
                style="
                  height: 40px;
                  width: 110px;
                  font-size: 22px;
                  padding: 5px;
                "
              >
                <img
                  @click="initVeris()"
                  :src="'data:image/png;base64,' + Picturebases"
                  alt="无效"
                  style="height:40px; width:110px"
                />
              </div>
            </span>
          </el-col>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button
          style="margin-top:10px;"
          type="primary"
          @click="bbb($event, 'name')"
          >确 定</el-button
        >
        <el-button @click="ccc">取 消</el-button>
      </div>
    </el-dialog>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
var timeStop;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
import Login_WeiXin from "../../components/Login/Login_WeiXin";
import MasterButtom from "../../components/MasterButtom";
import axios from "../../assets/config/axios.config";
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
export default {
  name: "login",
  data() {
    return {
      dialogVisible: false,
      loading: true,
      showWx: false,
      userhid: false,
      passhid: false,
      yzhid: false,
      isweixin: false,
      activeName: "first",
      activeNames: "firsts",
      isphone: false,
      isphones: false,
      ismobe: false,
      pwdFalseShow: false,
      pwdTiShi: "",
      pwdErr: false,
      phoneTiShi: "",
      userTishi: "",
      src: "",
      carousel: "",
      Code: "",
      timeStop: "",
      GUIDS: "",
      isShowss: false,
      isShows: false,
      isshuru: false,
      isshurus: true,
      ItemCounta: "",
      phoneTiShis:'',
      Picturebases: "",
      Type: "",
      yzcodesss: "",
      form: {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
        yzcodes: "",
      },
      checked: "",
      title: "",
      titlea: "",
      num: 1,
      roleName: "",
      Picture: "",
      Picturebase: "",
      codeImg: require("../../assets/images/timg.jpg"),
      GUID: "",
      wx: "",
      tab: 1,
      status: 0,
      isLoginCode: false,
      mobelEm: "",
      yzcodesTiShi: "",
      timer: null,
      codeTiShis: "",
      isShow: false,
      TempGuid: "",
      isMobile: false,
      canClick: true,
    };
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },
  deactivated() {
    window.clearInterval(timeStop);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    localStorage.removeItem("route");
  },

  deactivated() {
    this.form = {
      name: "",
      type: "",
      pass: "",
      user: "",
      yzcode: "",
      yzcodes: "",
    };
  },
  async mounted() {
    this.initVeri();
    if (this.$route.query.Guid) {
      let data = {
        guid: this.$route.query.Guid,
        ts: this.$route.query.ts,
        js: this.$route.query.js,
      };
      let res = await this.$store.dispatch("_getMMDL", data);
      if (res.data.IsSuccess) {
        if (!res.data.Data.IsGo) {
          this.pwdFalseShow = true;
          return;
        }
        localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
        this.$store.dispatch("_GetRouter").then((res) => {
          localStorage.setItem("route", JSON.stringify(res.data.Data));
        });

        this.timer = setTimeout(() => {
          window.location.href = res.data.Data.URL;
        }, 2000);
      } else {
        // this.$message({
        //   showClose: true,
        //   message: res.data.Message,
        //   type: "err",
        // });
        this.$confirm(res.data.Message, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });

        // alert(res.data.Message);
      }
    } else {
      if (window.localStorage.getItem("userInfo")) {
        window.location.href = "/";
      } else {
        window.addEventListener("setItem", () => {
          let carousel = JSON.parse(sessionStorage.getItem("eqcode"));
          this.loading = false;
          this.$parent.loading = false;
          this.src = carousel.src;
          this.Code = carousel.Code;
        });
      }
    }
    if (this.$route.query.Login) {
      this.num = this.$route.query.Login;
    } else {
      if (sessionStorage.getItem("Login")) {
        this.num = sessionStorage.getItem("Login");
      } else {
        this.num = 1;
      }
    }

    let params = [
      1000,
      1001,
      4530,
      6018,
      6019,
      230,
      6055,
      5000,
      5010,
      99,
      96,
      11,
      2960,
      6021,
      6022,
      310,
      12,
      101,
    ];
    this.$store.dispatch("_getSet", params).then((res) => {
      sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
      let SetItem = res.data.Data;
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == "是") {
            this.isphone = true;
          } else {
            this.isphone = false;
          }
        }
        if (item.SetItemID == 12) {
          if (item.Item_Value == "是") {
            this.isphones = true;
          } else {
            this.isphones = false;
          }
        }
        if (item.SetItemID == 101) {
          if (item.Item_Value == "是") {
            this.isMobile = true;
          } else {
            this.isMobile = false;
          }
        }
        if (this.isEmail) {
          if (this.isphone) {
            this.type = 2;
            this.types = 0;
          } else {
            this.type = 2;
            this.types = 0;
          }
        } else {
          if (this.isphone) {
            this.type = 3;
            this.types = 2;
          } else {
            this.type = 1;
            this.types = 1;
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == "是") {
            this.isweixin = true;
          } else {
            this.isweixin = false;
          }
        }
        if (item.SetItemID == 6022) {
          if (item.Item_Value == "是") {
            this.isLoginCode = true;
          } else {
            this.isLoginCode = false;
          }
        }
      });
    });

    if (localStorage.getItem("Logintype") == "email") {
      this.tab = 2;
      this.activeName = "second";
    } else if (localStorage.getItem("Logintype") == "phone") {
      this.tab = 3;
      this.activeName = "third";
    }
    if (this.num == "1") {
      this.title = "作者登录";
      this.titlea = "在线投稿系统";
      this.roleName = "Authors";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Authors_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_user")).pass
          );
        }
      } else if (this.tab == 2) {
        if (JSON.parse(localStorage.getItem("user_Authors_email"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Authors_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Authors_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Authors_phone")).pass
          );
        }
      }
    } else if (this.num == "3") {
      this.title = "专家登录";
      this.titlea = "专家审稿系统";
      this.roleName = "Experts";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Experts_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_user")).pass
          );
        }
      } else if (this.tab == 2) {
        this.checked = true;
        if (JSON.parse(localStorage.getItem("user_Experts_email"))) {
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Experts_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Experts_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Experts_phone")).pass
          );
        }
      }
    } else if (this.num == "2") {
      this.title = "编辑登录";
      this.titlea = "编辑办公系统";
      this.roleName = "Editors";
      if (this.tab == 1) {
        if (JSON.parse(localStorage.getItem("user_Editors_user"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_user")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_user")).pass
          );
        }
      } else if (this.tab == 2) {
        this.checked = true;
        if (JSON.parse(localStorage.getItem("user_Editors_email"))) {
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_email")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_email")).pass
          );
        }
      } else {
        if (JSON.parse(localStorage.getItem("user_Editors_phone"))) {
          this.checked = true;
          this.form.user = JSON.parse(
            localStorage.getItem("user_Editors_phone")
          ).name;
          this.form.pass = this.Decrypt(
            JSON.parse(localStorage.getItem("user_Editors_phone")).pass
          );
        }
      }
    }
  },

  methods: {
    oninput() {
      if (this.form.user == "") {
        this.form.pass = "";
      }
    },
    handleQrcodeCheck(type) {
      var urldomain = "";
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch("_getWeiXinLogin", { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              //判断权限
              var roleId = res.data.Data.RoleID.toString();
              if (type == 2 && roleId.indexOf("Editors") != -1) {
                this.$message({ message: "登录成功", type: "success" });
                localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
                urldomain = "/editor/#/editor/Index";
              } else if (type == 3 && roleId.indexOf("Experts") != -1) {
                this.$message({ message: "登录成功", type: "success" });
                localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
                urldomain = "/expert/#/examine-manuscripts";
              } else if (type == 1 && roleId.indexOf("Authors") != -1) {
                this.$message({ message: "登录成功", type: "success" });
                localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
                urldomain = "author/#/author-index";
              } else {
                this.$message({
                  showClose: true,
                  message: "登录失败，该用户不具备相应角色。",
                  type: "error",
                });
                urldomain = "/";
              }
              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              this.$store.dispatch("_GetRouter").then((res) => {
                localStorage.setItem("route", JSON.stringify(res.data.Data));
              });
              setTimeout(() => {
                window.location.href = urldomain;
              }, 3000);
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true;
                return;
              }
            }
          });
      }, 2000);
    },
    async aaa() {
      if (this.form.user) {
        //0: Email 1:用户名 2: 手机
        this.Type = -1;
        if (this.$Bai(this.form.user)) {
          this.$message({
            showClose: true,
            message: "邮箱或手机号不能为空",
            type: "error",
          });
          return;
        } else if (this.$base(this.form.user, "phone")) {
          this.Type = 2;
        } else if (this.$base(this.form.user, "email")) {
          this.Type = 0;
        } else {
          this.$message({
            showClose: true,
            message: "您的手机号格式不对或者含有非法字符",
            type: "error",
          });
          return;
        }
        this.isShowss = true;
        this.initVeris();
      }
    },
    async bbb() {
      if (
        this.yzcodesss == "" ||
        this.yzcodesss == null ||
        this.yzcodesss == undefined
      ) {
        this.phoneTiShis = "验证码不能为空";
        console.log(111);
        return;
      } else {
        if (this.yzcodesss.length < 6) {
          this.phoneTiShis = "请输入正确的验证码";
          console.log(111);
          return;
        } else {
          this.phoneTiShis = "";
          console.log(111);
        }
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch("_getRegDeteCt", {
        Account: this.form.user,
        Type: 2,
        Guid: this.GUIDS,
        VCode: this.yzcodesss,
      });
      if (res.data.IsSuccess == false) {
        this.phoneTiShis = res.data.Message;
        this.initVeris();
      } else {
        this.isShowss = false;
        this.yzcodesss = "";
        this.phoneTiShis = "";
        this.ItemCounta = res.data.ItemCount;
        if (res.data.ItemCount >= 1) {
          this.isShows = true;
          this.isshurus = false;
        } else {
          this.$message({
            showClose: true,
            message: "您的手机号还没有注册过，无法登录",
            type: "error",
          });
        }
      }
    },
    ccc() {
      this.isShowss = false;
      this.yzcodesss = "";
      this.phoneTiShis = "";
    },
    async sendCodeBtn(elem, str) {
      //点击发送验证码
      //0: Email 1:用户名 2: 手机 3： 手机验证码
      let Type = 2;
      let names = this.form.user;
      let codes = this.form.yzcode;
      //验证email和手机是否注册过
      if (this.ItemCounta > 0) {
        this.$store
          .dispatch("_getRegSendCode", {
            MobileEmail: names,
            VCode: codes,
            Guid: this.GUID,
            CRCeMethod: 2,
            LookforPassword: true,
          })
          .then((res) => {
            if (res.data.IsSuccess) {
              this.isShow = true;
              this.TempGuid = res.data.Data.TempGuid;
            } else {
              this.initVeri();
              alert(res.data.Message);
            }
          });
      } else {
        alert("您的手机号未注册！");
      }
    },
    //解密方法
    Decrypt(word) {
      let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    },
    //加密方法
    Encrypt(word) {
      let srcs = CryptoJS.enc.Utf8.parse(word);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.ciphertext.toString().toUpperCase();
    },
    async wxshow() {
      this.dialogVisible = true;
      let carousel = await this.$store.dispatch("_getGetQrcode");
      if (carousel) {
        this.src = carousel.data.Url;
        this.Code = carousel.data.Code;
        this.loading = false;
        this.handleQrcodeCheck(this.num);
        this.$emit("func", this.src);
      }
    },
    getMsgFormSon(data) {
      this.loading = false;
      this.wx = data;
    },
    dialoga(data) {
      this.dialogVisible = false;
    },
    handleClick(tab, event) {
      this.tab = parseInt(tab.index) + 1;
      this.form = {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
        yzcodes: "",
      };
      this.userhid = false;
      this.phoneTiShi = "";
      this.passhid = false;
      this.yzhid = false;
      (this.status = 0), (this.mobelEm = ""), (this.yzcodesTiShi = "");
    },
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (elem.target.value != "") {
        this.passhid = "";
      }
      if (type == "phone") {
        if (this.$Bai(elem.target.value)) {
          return (this.phoneTiShi = "请输入手机号码");
        }
        if (this.$Space(elem.target.value)) {
          return (this.phoneTiShi = "手机号不能含有空格");
        }
        if (!this.$base(elem.target.value, "phone")) {
          return (this.phoneTiShi = "请输入正确格式的手机号码");
        } else {
          return (this.phoneTiShi = "");
        }
      }
      if (type == "pws") {
        if (this.$Bai(elem.target.value)) {
          this.passhid = "请输入密码！";
          return;
        } else if (this.$Space(elem.target.value)) {
          this.passhid = "";
          this.pwdErr = true;
          return;
        } else if (this.$base(elem.target.value, "aff")) {
          this.passhid = "";
          this.pwdErr = true;
          return;
        } else if (!this.$base(elem.target.value, "users")) {
          this.passhid = "";
          this.pwdErr = true;
          return;
        } else {
          this.pwdErr = false;
          this.pwdTiShi = "";
        }
      }

      if (type == "user") {
        if (this.$Bai(elem.target.value)) {
          this.userTishi = "用户名不能为空";
        } else {
          this.userTishi = "";
        }
      }
    },
    async Login(num, at) {
      if (!this.canClick) return;
      this.canClick = false;
      setTimeout(() => {
        this.canClick = true;
      }, 3000);
      var Type = "";
      var UserKey = "";
      this.userhid = "";
      this.passhid = "";
      this.yzhid = "";
      if (num == 1) {
        Type = 1; //用户登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入用户名");
        }
        // if (!this.$base(this.form.user,"user")){
        //   return this.userhid="您的用户名格式不正确"
        // }
      } else if (num == 2) {
        Type = 2; //邮箱登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入邮箱");
        }
        if (!this.$base(this.form.user, "email")) {
          return (this.userhid = "您的邮箱格式不正确");
        }
      } else if (num == 3) {
        Type = 3; //手机号登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入手机号");
        }
        if (!this.$base(this.form.user, "phone")) {
          return (this.userhid = "您的手机号格式不正确");
        }
      } else if (num == 4) {
        Type = 4; //手机验证码登录
        if ((this.form.user == "") | null) {
          return (this.userhid = "请输入手机号");
        }
        if (!this.$base(this.form.user, "phone")) {
          return (this.userhid = "您的手机号格式不正确");
        }
      }

      if (Type != 4) {
        if ((this.form.pass == "") | null) {
          this.pwdFalseShow = false;
          return (this.passhid = "请输入密码");
        }
        if (this.form.yzcode.length != 6) {
          return (this.yzhid = "请输入六位数的验证码");
        }
        if (this.$Space(this.form.pass)) {
          this.pwdFalseShow = true;
          return;
        } else if (this.$base(this.form.pass, "aff")) {
          this.pwdFalseShow = true;
          return;
        } else if (!this.$base(this.form.pass, "users")) {
          this.pwdFalseShow = true;
          return;
        } else {
          this.pwdFalseShow = false;
        }
      }
      if (at == 2) {
        if (this.form.yzcodes == "" || !this.form.yzcodes) {
          return (this.yzcodesTiShi = "请输入邮箱或手机收到的六位数验证码");
        }
      }
      if (Type == 4) {
        var datas = {
          Type: 4,
          UserKey: this.form.user,
          pwm: "",
          pwaes: "",
          GUID: this.TempGuid,
          VCode: "",
          roleName: this.roleName,
          Code: this.form.yzcodes,
        };
      } else {
        let pwm = md5(this.form.pass + "!@*Samson*@!");
        let pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString();
        var datas = {
          Type,
          UserKey: this.form.user,
          pwm,
          pwaes,
          GUID: this.GUID,
          VCode: this.form.yzcode,
          roleName: this.roleName,
          Code: this.form.yzcodes,
        };
      }
      //验证输入内容完毕  准备登录

      let res = await this.$store.dispatch("_postLogin", datas);
      if (res.data.IsSuccess) {
        if (at == 1) {
          this.status = 1;
          this.mobelEm = res.data.Message;
          return;
        }
        if (!res.data.Data.IsGo) {
          this.pwdFalseShow = true;
          return;
        }
        let user = {
          name: "",
          pass: "",
        };
        let loginData = {
          IsGo: res.data.Data.IsGo,
          GoPath: res.data.Data.GoPath,
        };

        localStorage.setItem("loginData", JSON.stringify(loginData));

        if (this.checked) {
          if (this.num == "1") {
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Authors_user", JSON.stringify(user));
            } else if (Type == 3 || Type == 4) {
              localStorage.setItem("user_Authors_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Authors_email", JSON.stringify(user));
            }
          } else if (this.num == "3") {
            //专家登录
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Experts_user", JSON.stringify(user));
            } else if (Type == 3 || Type == 4) {
              localStorage.setItem("user_Experts_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Experts_email", JSON.stringify(user));
            }
          } else if (this.num == "2") {
            user.name = this.form.user;
            user.pass = this.Encrypt(this.form.pass);
            if (Type == 1) {
              localStorage.setItem("user_Editors_user", JSON.stringify(user));
            } else if (Type == 3 || Type == 4) {
              localStorage.setItem("user_Editors_phone", JSON.stringify(user));
            } else {
              localStorage.setItem("user_Editors_email", JSON.stringify(user));
            }
          }
        } else {
          if (this.num == "1") {
            if (Type == 1) {
              localStorage.removeItem("user_Authors_user");
            } else if (Type == 3 || Type == 4) {
              localStorage.removeItem("user_Authors_phone");
            } else {
              localStorage.removeItem("user_Authors_email");
            }
          } else if (this.num == "3") {
            //专家登录
            if (Type == 1) {
              localStorage.removeItem("user_Experts_user");
            } else if (Type == 3 || Type == 4) {
              localStorage.removeItem("user_Experts_phone");
            } else {
              localStorage.removeItem("user_Experts_email");
            }
          } else if (this.num == "2") {
            if (Type == 1) {
              localStorage.removeItem("user_Editors_user");
            } else if (Type == 3 || Type == 4) {
              localStorage.removeItem("user_Editors_phone");
            } else {
              localStorage.removeItem("user_Editors_email");
            }
          }
        }
        if (Type == 1) {
          localStorage.setItem("Logintype", "user");
        } else if (Type == 3 || Type == 4) {
          localStorage.setItem("Logintype", "phone");
        } else {
          localStorage.setItem("Logintype", "email");
        }
        this.$message({
          showClose: true,
          message: "登录成功，跳转中·······",
          type: "success",
          duration: 1800,
        });
        localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
        this.$store.dispatch("_GetRouter").then((res) => {
          localStorage.setItem("route", JSON.stringify(res.data.Data));
        });
        setTimeout(() => {
          if (this.num == 1) {
            // localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/author/#/";
            window.location.href = urldomain;
            return;
          } else if (this.num == 2) {
            const hostname = document.location.hostname;
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/editor/#/editor/Index";
            window.location.href = urldomain;
            return;
          } else if (this.num == 3) {
            // localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            const hostname = document.location.hostname;
            if (!res.data.Data.IsGo) {
              location.href = res.data.Data.GoPath + "?firstLogin=true";
              return;
            }
            var urldomain = "/expert/#/examine-manuscripts";
            window.location.href = urldomain;
            return;
          }
        }, 3000);
      } else {
        this.initVeri();
        this.$message({
          showClose: true,
          message: res.data.Message,
          type: "error",
        });
      }
    },
    //页面初始化形成验证码以及GUID
    async initVeri() {
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID;
        this.Picturebase = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },

    useqqlogin() {
      var urldz =
        "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" +
        window.OpenId +
        "&response_type=token&scope=all&redirect_uri=http%3A%2F%2F" +
        window.callBackHtp +
        "%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    async initVeris() {
      var random_number = Math.floor(Math.random() * (100 + 1));
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUIDS = resbase.data.Data.GUID;
        this.Picturebases = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },
  },
};
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.loginbtn .el-button--primary {
  width: 100% !important;
}
.yzms {
  float: left;
}
@media only screen and (max-width: 320px) {
  .yamsss {
    width: 70px !important;
  }
}
.el-button--primary.is-plain {
  color: #fff;
}
::v-deep .dialogwidth {
  width: 22% !important;
}
@media screen and (max-width: 1400px) and (min-width: 768px) {
  ::v-deep .dialogwidth {
    width: 40% !important;
  }
}
@media screen and (max-width: 768px) and (min-width: 440px) {
  ::v-deep .dialogwidth {
    width: 60% !important;
  }
}
@media (max-width: 440px) {
  ::v-deep .dialogwidth {
    width: 80% !important;
  }
  .myzm {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
.el-dialog__footer {
  text-align: center !important;
}
</style>
